import $ from "jquery";
import React from "react";
import arrowIcon from "../assets/img/arrow_down.png";
import {Button} from "react-bootstrap";

var dateFormat = require("dateformat");
var moment = require("moment");
var validUrl = require("valid-url");

export const helperFunctions = {
    getRole,
    focusInput,
    returnLabelWithValue,
    returnLabelWithValueCustom,
    returnLabelsWithValues,
    returnLabelsWithValueOtherThenLabel,
    isEmpty,
    returnOptionWithDisble,
    returnFormats,
    returnExtFromImage,
    returnKeyWithColumnMatch,
    returnColumnValueWithColumnMatch,
    returnKeys,
    omitKeys,
    sortObjectWithDefineKeys,
    openModal,
    closeModal,
    showDate,
    overRideDuplicateImage,
    removeDuplicateImage,
    returnTimeStamp,
    hasRole,
    optionsHasRole,
    checkLoggedInUserById,
    toggleModal,
    inputChangeHandler,
    isLoggedIn,
    getInitials,
    colorForBardcodeWithDate,
    returnLabelWithValueGroup,
    returnTitleWithId,
    returnBooleanWithColumnMatch,
    appendCount,
    appendValues,
    checkClosestDatatype,
    Capitalize,
    consoleFormData,
    checkRoleAndDisplayMenu,
    makeRoleBasedUrl,
    removeUnderScore,
    returnTitleWithDb_column,
    convertToBool,
    returnLookupTableNameWithId,
    returnTitleWithValue
};


function getRole() {
    var userAdmin = JSON.parse(localStorage.getItem("user"));
    if (userAdmin) {
        return userAdmin.user.roles;
    }
}

function focusInput(objectTemp) {
    let properties = Object.keys(objectTemp).reverse();
    for (var key in properties) {
        if (objectTemp[properties[key]] !== null) {
            var myEle = $("#" + properties[key]);
            // console.log('myEle', myEle);
            if (myEle) {
                var scrollPos = $(myEle).offset().top;
                $(window).scrollTop(scrollPos);
            }

            // $("#"+properties[key]).focus();
        }
    }
}

function returnExtFromImage(imageName) {
    var ext = imageName.substr(imageName.lastIndexOf(".") + 1);
    return ext;
}

function returnOptionWithDisble(value, ObjectArray) {
    var newObject = [];
    for (var key in ObjectArray) {
        if (ObjectArray[key]["value"] === value) {
            newObject.push({
                value: ObjectArray[key]["value"],
                label: ObjectArray[key]["label"],
                disabled: true
            });
        } else {
            newObject.push({
                value: ObjectArray[key]["value"],
                label: ObjectArray[key]["label"]
            });
        }
    }
    return newObject;
}

function returnFormats(ObjectArray, columnName) {
    var newObject = [];
    for (var key in ObjectArray) {
        newObject.push(ObjectArray[key][columnName]);
    }
    return newObject;
}

function Capitalize(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : ''
}

function removeUnderScore(str) {
    return str.replace(/_/g, " ");
}

function returnLabelWithValue(value, ObjectArray, defaultLabel = null) {
    if (value) {
        for (var key in ObjectArray) {
            if (ObjectArray[key]["value"] === value) {
                return {
                    value: ObjectArray[key]["value"],
                    label: ObjectArray[key]["label"]
                };
            }
        }
    } else if (defaultLabel) {
        for (var keyN in ObjectArray) {
            if (ObjectArray[keyN]["label"] === defaultLabel) {
                return {
                    value: ObjectArray[keyN]["value"],
                    label: ObjectArray[keyN]["label"]
                };
            }
        }
    }
    return null;
}

function returnLabelWithValueCustom(
    value,
    ObjectArray,
    defaultLabel = null,
    defaultValue = null
) {
    if (value) {
        for (var key in ObjectArray) {
            // console.log("_________________________");
            // console.log(
            //     value +
            //         "," +
            //         ObjectArray[key]["label"] +
            //         "," +
            //         defaultLabel +
            //         "," +
            //         defaultValue
            // );
            if (ObjectArray[key]["value"] === value) {
                if (value == defaultValue) {
                    return {
                        value: ObjectArray[key]["value"],
                        label:
                            defaultLabel !== null
                                ? defaultLabel
                                : ObjectArray[key]["label"]
                    };
                } else {
                    return {
                        value: ObjectArray[key]["value"],
                        label: ObjectArray[key]["label"]
                    };
                }
            }
        }
    } else if (defaultLabel) {
        for (var keyN in ObjectArray) {
            if (ObjectArray[keyN]["label"] === defaultLabel) {
                return {
                    value: ObjectArray[keyN]["value"],
                    label: defaultLabel
                };
            }
        }
    }
    return null;
}

// by

function returnTitleWithId(id, ObjectArray, defaultLabel = null) {
    if (id) {
        for (var key in ObjectArray) {
            if (ObjectArray[key]["id"] === id) {
                return {
                    id: ObjectArray[key]["id"],
                    title: ObjectArray[key]["title"]
                };
            }
        }
    } else if (defaultLabel) {
        for (var keyN in ObjectArray) {
            if (ObjectArray[keyN]["title"] === defaultLabel) {
                return {
                    id: ObjectArray[keyN]["id"],
                    title: ObjectArray[keyN]["title"]
                };
            }
        }
    }
    return null;
}


function returnTitleWithValue(value, ObjectArray, defaultLabel = null) {
    if (value) {
        for (var key in ObjectArray) {
            if (ObjectArray[key]["title"] === value) {
                return {
                    id: ObjectArray[key]["id"],
                    title: ObjectArray[key]["title"]
                };
            }
        }
    } else if (defaultLabel) {
        for (var keyN in ObjectArray) {
            if (ObjectArray[keyN]["title"] === defaultLabel) {
                return {
                    id: ObjectArray[keyN]["id"],
                    title: ObjectArray[keyN]["title"]
                };
            }
        }
    }
    return null;
}

//
function returnLabelWithValueGroup(value, ObjectArray) {
    if (value) {
        for (var key in ObjectArray) {
            for (var k in ObjectArray[key]["options"]) {
                if (ObjectArray[key]["options"][k]["value"] === value) {
                    return {
                        value: ObjectArray[key]["options"][k]["value"],
                        label: ObjectArray[key]["options"][k]["label"]
                    };
                }
            }
        }
    }
    return null;
}

function returnLabelsWithValues(values, ObjectArray) {
    var temp = [];

    if (values.length > 0) {
        for (var key in ObjectArray) {
            if (values.includes(ObjectArray[key]["value"])) {
                temp.push({
                    value: ObjectArray[key]["value"],
                    label: ObjectArray[key]["label"]
                });
            }
        }
    } else {
        return null;
    }
    return temp;
}

function returnLabelsWithValueOtherThenLabel(
    value,
    ObjectArray,
    keyValue,
    keyLabel
) {
    if (value) {
        for (var key in ObjectArray) {
            if (ObjectArray[key][keyValue] === value) {
                var data = {
                    value: ObjectArray[key][keyValue],
                    label: ObjectArray[key][keyLabel]
                };

                return data;
            }
        }
    }

    return null;
}

/*Return array key if key index match to define column*/
function returnKeyWithColumnMatch(columnName, ObjectArray, value) {
    for (var key in ObjectArray) {
        if (ObjectArray[key][columnName] === value) {
            return key;
        }
    }
    return null;
}

function isEmpty(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
}

function returnColumnValueWithColumnMatch(
    ObjectArray,
    columnNameReturn,
    columnMatch,
    columnMatchName
) {
    if (ObjectArray.length > 0) {
        for (var key in ObjectArray) {
            if (columnMatch) {
                if (columnMatch.includes(ObjectArray[key][columnMatchName])) {
                    return ObjectArray[key][columnNameReturn];
                }
            }
        }
    }
    return null;
}

function returnKeys(Obj) {
    var keys = [];
    for (var key in Obj) {
        if (typeof Obj[key] === "object") {
            console.log("objet key", key);
            this.returnKeys(Obj[key]);
        } else {
            console.log("key", key);
        }
    }
    return keys;
}

function omitKeys(obj, not) {
    var result = Object.assign({}, obj);
    for (let n of not) delete result[n];
    return result;
}

function sortObjectWithDefineKeys(object, keysObject) {
    // console.log('1', object.hasOwnProperty('discount')?'1':'2');
    // console.log('2', keysObject);
    let tempObject = {};
    for (var key in keysObject) {
        // console.log('key', keysObject[key]);
        if (object.hasOwnProperty(keysObject[key])) {
            // console.log('1', object[keysObject[key]]);
            tempObject[keysObject[key]] = object[keysObject[key]];
        }
    }
    // console.log('tempObject', tempObject);
    return tempObject;
    // console.log('tempObject', tempObject);
}

function openModal(name) {
    this.setState({
        [name]: true
    });
}

function closeModal(modalName) {
    this.setState({
        [modalName]: false
    });
}

function showDate(data) {
    const months = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
    ];
    const date = new Date(data);
    const d = date.getDate();
    let prefix;
    if (d > 3 && d < 21) {
        prefix = "th";
    } else {
        switch (d % 10) {
            case 1:
                prefix = "st";
                return prefix;
            case 2:
                prefix = "nd";
                return prefix;
            case 3:
                prefix = "rd";
                return prefix;
            default:
                break;
        }
    }
    return `${
        months[date.getMonth()]
    } ${date.getDate()}${prefix} ,${date.getFullYear()}`;
}

function overRideDuplicateImage(currentImgs, AllImgs) {
    // for(var i in currentImgs ) {
    // 	for(var j in AllImgs) {
    // 	}
    // }
}

function removeDuplicateImage(val, AllImgs) {
    for (var i in AllImgs) {
        if (AllImgs[i].name === val.name) {
            if (AllImgs[i].file === val.file)
                return {
                    val: val,
                    duplicate: true,
                    name: val.name,
                    index: i,
                    message: val.name + " Image name and file is same"
                };
            else
                return {
                    val: val,
                    duplicate: true,
                    name: val.name,
                    index: i,
                    message: val.name + " Image file name is same"
                };
        }
    }
    return {duplicate: false, val: val, name: val.name};
}

function returnTimeStamp(dataString) {
    const dateTime = new Date(dataString).getTime();
    const timestamp = Math.floor(dateTime / 1000);
    return timestamp;
}

function hasRole(role) {
    let AdminUser = JSON.parse(localStorage.getItem("user"));
    if (AdminUser && AdminUser.result) {
        for (var i in AdminUser.result.user.roles) {
            var temp = AdminUser.result.user.roles[i];
            //console.log(temp);
            if (role.includes(temp.name)) {
                return true;
            }
        }
        return false;
    } else {
        return false;
    }
}

function checkRoleAndDisplayMenu(rolesToCheck) {
    let AdminUser = JSON.parse(localStorage.getItem("user"));
    if (AdminUser && AdminUser.result) {
        for (var i in AdminUser.result.user.roles) {
            var temp = AdminUser.result.user.roles[i];
            if (rolesToCheck.includes(temp.name)) {
                return true;
            }
        }
    }
    return false;
}

function makeRoleBasedUrl(rolesToCheck) {
    let AdminUser = JSON.parse(localStorage.getItem("user"));
    if (AdminUser && AdminUser.result) {
        for (var i in AdminUser.result.user.roles) {
            var temp = AdminUser.result.user.roles[i];
            if (rolesToCheck.includes(temp.name)) {
                return AdminUser.result.user.model_id;
            }
        }
    }
    return "all";
}

function optionsHasRole(options, roleName) {
    var temp = [];
    for (var i in options) {
        for (var j in options[i].roles) {
            if (options[i].roles[j].name === roleName) {
                temp.push(options[i]);
            }
        }
    }
    return temp;
}

function checkLoggedInUserById(id) {
    let AdminUser = JSON.parse(localStorage.getItem("user"));
    if (AdminUser && AdminUser.token) {
        return AdminUser.user.id === id ? true : false;
    } else {
        return false;
    }
}

function toggleModal(name) {
    this.setState({
        [name]: !this.state[name]
    });
}

function inputChangeHandler(e) {
    this.setState({
        [e.target.name]: e.target.value
    });
}

function isLoggedIn() {
    let AdminUser = JSON.parse(localStorage.getItem("user"));
    return AdminUser && AdminUser.token ? true : false;
}

function getInitials(name, delimeter) {
    if (name) {
        var array = name.split(delimeter);
        switch (array.length) {
            case 1:
                return array[0].charAt(0).toUpperCase();
            //break;
            default:
                return (
                    array[0].charAt(0).toUpperCase() +
                    array[array.length - 1].charAt(0).toUpperCase()
                );
        }
    }

    return false;
}

function colorForBardcodeWithDate(date, dateName) {
    var color = "";
    if (date && dateName === "videoSpecialNeedDate") {
        color = "barcode-color-red";
    } else if (date && dateName === "lastDayOfSchool") {
        var diff = moment().diff(date, "days");
        if (diff > 0 && diff <= 5) {
            color = "barcode-color-yellow";
        }
    }
    return color;
}

function returnBooleanWithColumnMatch(options, index, value) {
    for (var i in options) {
        if (index in options[i]) {
            if (options[i][index] == value) {
                return true;
            }
        }
    }
    return false;
}

/*append count with colmn name*/
function appendCount(options, columnName) {
    for (var i in options) {
        options[i][columnName] = parseInt(i, 10);
    }
    return options;
}

/*Append values in an array*/
function appendValues(options, values) {
    // console.log('values', values);
    for (var i in options) {
        for (var j in values) {
            options[i][values[j]["column"]] = values[j]["value"];
        }
    }
    return options;
}

function checkClosestDatatype(value) {
    let datatype = '';
    if (value !== undefined) {
        if (validUrl.isUri(value.toString())) {
            datatype = {
                value: "url",
                label: "URL"
            };
        } else if (Date.parse(value) && isNaN(value)) {
            datatype = {
                value: "datetime",
                label: "Date"
            };
        } else if (isNaN(value)) {
            if (value.length <= 255) {
                datatype = {
                    value: "string",
                    label: "Varchar String(0 - 255)"
                };
            } else {
                datatype = {
                    value: "text",
                    label: "Text String(0 - 65535)"
                };
            }
        } else if (!isNaN(value)) {
            if (value % 1 !== 0) {
                datatype = {
                    value: "float",
                    label: "Float"
                };
            }
            if (value % 1 === 0) {
                datatype = {
                    value: "integer",
                    label: "Integer"
                };
            }
        }
    } else if (value === undefined) {
        datatype = {
            value: "string",
            label: "Varchar String(0 - 255)"
        };
    }
    return datatype;
}


function returnTitleWithDb_column(db_column, ObjectArray, defaultLabel = null) {
    if (db_column) {
        for (var key in ObjectArray) {
            if (ObjectArray[key]["db_column"] === db_column) {
                return {
                    db_column: ObjectArray[key]["db_column"],
                    title: ObjectArray[key]["title"]
                };
            }
        }
    } else if (defaultLabel) {
        for (var keyN in ObjectArray) {
            if (ObjectArray[keyN]["title"] === defaultLabel) {
                return {
                    db_column: ObjectArray[keyN]["db_column"],
                    title: ObjectArray[keyN]["title"]
                };
            }
        }
    }
    return null;
}


function returnLookupTableNameWithId(table_name, ObjectArray, defaultLabel = null) {
    if (table_name) {
        for (var key in ObjectArray) {
            if (ObjectArray[key]["table_name"] === table_name) {
                return {
                    table_name: ObjectArray[key]["table_name"]
                };
            }
        }
    } else if (defaultLabel) {
        for (var keyN in ObjectArray) {
            if (ObjectArray[keyN]["table_name"] === defaultLabel) {
                return {
                    table_name: ObjectArray[keyN]["table_name"],
                };
            }
        }
    }
    return null;
}

function consoleFormData(formData) {
    //Log the key/value pairs
    for (var pair of formData.entries()) {
        console.log(pair[0] + " - " + pair[1]);
    }
}

function convertToBool(value) {
    if (value == 1) {
        return true;
    } else if (value == 0) {
        return false;
    }
    // return !(!(+value)); // true
}



// WEBPACK FOOTER //
// ./src/helper/helperFunctions.js